/**
 * Leitura da lista de projetos do DinaBox (proxy do backend).
 *
 * O adapter do ERP traduz o vocabulario do fornecedor antes de entregar:
 * a chave da lista e `projetos` e cada item vem como
 * `{id, nome, cliente, status, bruto}` — `bruto` guarda o original.
 * Antes disso a resposta saia quase crua (`projects` com `project_id`,
 * `project_description`...). Esta tela nasceu no formato antigo e, quando a
 * traducao entrou, passou a ler uma chave que nao existe mais: em
 * JavaScript isso nao da erro, da `undefined` — e a tela ficou vazia em
 * silencio (2026-08-19).
 *
 * Aqui a leitura aceita os DOIS formatos e devolve sempre o vocabulario
 * interno da pagina (`project_*`), que e o mesmo das listas ja salvas no
 * historico — mudar isso invalidaria snapshot antigo.
 */

/** Um item da lista (contrato novo OU formato antigo) -> vocabulario da tela. */
export function projetoDaApi(p) {
  const bruto = (p && typeof p === "object" && p.bruto) || p || {};
  return {
    project_id: p?.id ?? bruto.project_id ?? "",
    project_description: p?.nome ?? bruto.project_description ?? "",
    project_client_name: p?.cliente ?? bruto.project_client_name ?? "",
    project_customer_name: bruto.project_customer_name ?? "",
    project_author_name: bruto.project_author_name ?? "",
    project_status: p?.status ?? bruto.project_status ?? "",
  };
}

/** Lista de projetos de uma pagina da resposta, em qualquer um dos formatos. */
export function projetosDaResposta(payload) {
  const lista = payload?.projetos ?? payload?.projects ?? [];
  return Array.isArray(lista) ? lista.map(projetoDaApi) : [];
}

/**
 * True quando o servidor diz ter projetos mas nenhum foi lido — sinal de que
 * o formato mudou de novo. Melhor gritar do que mostrar "nenhum projeto".
 */
export function formatoNaoReconhecido(payload, lidos) {
  return Number(payload?.total || 0) > 0 && lidos === 0;
}
